import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';

import { HeadquarterContext } from 'context/HeadquarterContext';

import { useAuth } from './useAuth';
import { useCubohActionBar } from './useCubohActionBar';

function useGlobalContextProperty(propertyName: string, propertyValue: unknown) {
  useEffect(() => {
    if (propertyValue) {
      datadogRum.setGlobalContextProperty(propertyName, propertyValue);
    }

    return () => {
      datadogRum.removeGlobalContextProperty(propertyName);
    };
  }, [propertyName, propertyValue]);
}

export default function useDataDogContextAttributes() {
  const { headquarter, location } = useContext(HeadquarterContext);
  const { cubohUser, user } = useAuth();
  const { singleSelectedMerchantID, singleSelectedCompanyID } = useCubohActionBar();

  // set some context properties in DD for easier searching
  useGlobalContextProperty('hqId', headquarter?.id);
  useGlobalContextProperty('locationId', location?.id);
  useGlobalContextProperty('userId', user?.id);
  useGlobalContextProperty('cubohUserId', cubohUser?.id);
  useGlobalContextProperty('cubohCompanyId', singleSelectedCompanyID);
  useGlobalContextProperty('cubohMerchantId', singleSelectedMerchantID);
}
